module.exports = __webpack_public_path__ + "../img/planner/diagram-3.png";